module.exports = __webpack_public_path__ + "9e6ff28a25f241457729b31815fbdd88.png";